import { useEffect, useMemo, useState } from "react";
import MaterialReactTableWithSearch from "../../../components/MaterialReactTable/MaterialReactTableWithSearch";
import { useData } from "../../../context/DataContext";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { deleteAdOption } from "../../../context/createAPI";
import { useNavigate } from 'react-router-dom';
import { APP_ROUTES } from "../../../config/appRoutes";
import SingleSelect from "../../../components/Selections/singleSelect";
import MultiSelectWithAll from "../../../components/Selections/multiSelectWithAll";
import {
    Box, IconButton, Tooltip, Card, CardContent, Grid, FormControl,
    FormControlLabel,
    Radio,
    RadioGroup, Divider,
} from "@mui/material";
import UpdateIcon from '@mui/icons-material/Update';


function AdOptionHistory() {
    const {
        years = [], adOptionData = [], villageGroups = [], user = [], farmers = [],
        handleAdOption, user_client_id,
        adOptionPagination = null,
        adOptionPage = 1,
        adOptionLimit = 10,
        adOptionLoading = false,
        handleAdOptionPageChange,
        handleAdOptionLimitChange,
    } = useData();
    const navigate = useNavigate();
    const rowActions = (user.user_level_id !== 1 && user.user_level_id !== 2 && user.user_level_id !== 3) ? true : false;
    const levelOptions = [{ value: 1, label: "Groups" }, ...user_client_id === 2 ? [] : [{ value: 2, label: "Villages" }]]
    const ffGroupData = villageGroups?.filter((item) => item.level_id === 4);
    const groupData = ffGroupData[0]?.data?.length > 0
        ? ffGroupData[0].data
            .filter(item => item.group_id !== "")
            .map((item) => ({ value: item.group_id, label: item.Groups }))
        : [];
    const villageData = ffGroupData[0]?.data.filter((item) => item.village_id !== "").map((item) => ({ value: item.village_id, label: item.village }));

    const [enableSelectAll] = useState(true);

    const [state, setState] = useState({
        year: +years[0].value ?? 1,
        getFilterData: adOptionData,
        selectedFarmers: [],
        selected_group_ids: [],
        selected_village_ids: [],
        villageDetails: villageData ? villageData : [],
        groupDetails: groupData ? groupData : [],
        selectedLevel: 1,
        farmerFilterData: []
    });


    const adOptionColumns = useMemo(
        () => [
            {
                accessorFn: (row, index) => index + 1,
                header: 'SNO',
                id: 'id',
                enableGlobalFilter: false,
            },
            user.user_level_id !== 1 && user.user_level_id !== 2
                ? (user.level_id === 1
                    ? { accessorKey: "village_name", header: "Village Name", Cell: ({ row }) => row.original.village_name || "-" }
                    : { accessorKey: "group_name", header: "Group Name", Cell: ({ row }) => row.original.group_name || "-" })
                : (state.selectedLevel === 2
                    ? { accessorKey: "village_name", header: "Village Name", Cell: ({ row }) => row.original.village_name || "-" }
                    : { accessorKey: "group_name", header: "Group Name", Cell: ({ row }) => row.original.group_name || "-" }),
            {
                header: "Farmer Name",
                accessorFn: (row) => row.farmer_name,
                Cell: ({ row }) => row.original.farmer_name || "-"
            },
            {
                accessorKey: "year",
                header: "Year",
                Cell: ({ row }) => row.original.year || "-"
            },
        ],
        [state.selectedLevel, user.user_id, user.user_level_id]
    );

    const renderRowActions = ({ row }) => (
        <Box sx={{ display: "flex", gap: "1rem" }}>
            <Tooltip title="Edit">
                <IconButton>
                    <UpdateIcon sx={{ color: "var(--success)" }} onClick={() => handleEdit(row)} />
                </IconButton>
            </Tooltip>

            <Tooltip title="Delete">
                <IconButton color="error">
                    <DeleteOutlineIcon onClick={() => handleDelete(row)} />
                </IconButton>
            </Tooltip>
        </Box>
    );

    const handleDelete = async (row) => {
        const confirmed = window.confirm(`Are You Sure You Want to Delete ${row.original.village_name}?`);
        if (!confirmed) {
            return;
        }
        try {
            const deleteApi = await deleteAdOption({
                id: row.original.id,
                updated_by: user.user_id
            });
            if (deleteApi.statusCode === 200) {
                handleAdOption();
                setState((prevState) => ({
                    ...prevState,
                    selectedVillageWiseOption: 1
                }))
            }
        } catch (error) {
            console.error(error);
        }
    };

    const handleEdit = (row) => {
        const rowData = row.original
        navigate(`${APP_ROUTES.ADOPTION.HISTORY_ROUTES.EDIT}`, { state: { rowData } });
    }


    const handleRadioChange = (e) => {
        const selectedValue = +e.target.value;

        setState(prevState => ({
            ...prevState,
            selectedLevel: selectedValue,
            selected_group_ids: selectedValue === 1 ? groupData : [],
            selected_village_ids: selectedValue === 2 ? villageData : [],
        }));
    };

    const handleInputChange = (name, value) => {
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    useEffect(() => {
        if (user.user_level_id !== 1 && user.user_level_id !== 2) {
            setState(prevState => ({ ...prevState, selected_village_ids: villageData, selected_group_ids: groupData }));
        } else {
            setState(prevState => ({ ...prevState, selected_group_ids: state.selectedLevel === 1 ? groupData : [], selected_village_ids: state.selectedLevel === 2 ? villageData : [] }));
        }
    }, [user.user_level_id]);



    useEffect(() => {
        const filtered = adOptionData.filter((book) => {
            const matchesFarmer = state.selectedFarmers ? state.selectedFarmers.some(f => f.value === book.farmer_id) : true;
            const matchesYear = state.year ? book.crop_year_id === parseInt(state.year) : true;
            return matchesFarmer && matchesYear;
        });
        setState(prevState => ({ ...prevState, getFilterData: filtered }));
    }, [state.selectedFarmers, state.year, adOptionData]);

    useEffect(() => {
        let filteredFarmersBasedOnSelected = [];
        if (state.selected_group_ids?.length > 0) {
            filteredFarmersBasedOnSelected = farmers.filter(farmer =>
                state.selected_group_ids.some(selected => parseInt(selected.value) === farmer.ff_group_id)
            );
        } else if (state.selected_village_ids?.length > 0) {
            filteredFarmersBasedOnSelected = farmers.filter(farmer =>
                state.selected_village_ids.some(selected => parseInt(selected.value) === farmer.village_id)
            );
        }

        setState(prevState => ({
            ...prevState,
            farmerFilterData: filteredFarmersBasedOnSelected,
            selectedFarmers: filteredFarmersBasedOnSelected.map(farmer => ({
                value: farmer.id,
                label: `${farmer.farmer_name} (${farmer.relative_name})`
            }))
        }));
    }, [state.selected_group_ids, state.selected_village_ids, farmers]);


    const adOptionFilters = [
        {
            id: 1,
            label: "Select Year",
            name: "year",
            value: state.year,
            options: years,
            type: "single",
        },
    ];

    if (user.user_level_id !== 1 && user.user_level_id !== 2) {
        if (user.level_id === 1) {
            adOptionFilters.push({
                id: 2,
                label: "Select Villages",
                name: "selected_village_ids",
                value: state.selected_village_ids,
                options: state.villageDetails,
                type: "multiple",
            });
        } else {
            adOptionFilters.push({
                id: 3,
                label: "Select Groups",
                name: "selected_group_ids",
                value: state.selected_group_ids,
                options: state.groupDetails,
                type: "multiple",
            });
        }
    } else {
        if (state.selectedLevel === 1) {
            adOptionFilters.push({
                id: 4,
                label: "Select Groups",
                name: "selected_group_ids",
                value: state.selected_group_ids,
                options: state.groupDetails,
                type: "multiple",
            });
        } else {
            adOptionFilters.push({
                id: 5,
                label: "Select Villages",
                name: "selected_village_ids",
                value: state.selected_village_ids,
                options: state.villageDetails,
                type: "multiple",
            });
        }
    }

    adOptionFilters.push({
        id: 6,
        label: "Select Farmers",
        name: "selectedFarmers",
        value: state.selectedFarmers,
        options: state.farmerFilterData?.map((item) => ({
            value: item.id,
            label: `${item.farmer_name} (${item.relative_name})`,
        })),
        type: "multiple",
    });

    const handleMultiSelectChange = (name, selectedValues = []) => {
        setState(prev => {
            // config for select-all comparison
            const config = {
                selected_village_ids: prev.villageDetails || [],
                selected_group_ids: prev.groupDetails || [],
            };

            const allOptions = config[name];

            let finalValues = selectedValues;

            // Apply select-all logic only for village & group
            if (allOptions) {
                if (enableSelectAll && selectedValues.length === allOptions.length) {
                    finalValues = allOptions;
                } else {
                    finalValues = selectedValues.length
                        ? [selectedValues[selectedValues.length - 1]]
                        : [];
                }
            }

            return {
                ...prev,
                [name]: finalValues,
            };
        });
    };


    return (
        <>
            <Box mt={1}>
                <Card elevation={6}>
                    <CardContent>
                        <Box sx={{ backgroundColor: "#fff", p: 0.5 }}>
                            {
                                (user.user_level_id === 1 || user.user_level_id === 2) && (
                                    <FormControl className="my-2">
                                        <RadioGroup
                                            row
                                            name="radioOption"
                                            value={+state.selectedLevel}   // ✅ string
                                            onChange={handleRadioChange}
                                        >
                                            {levelOptions.map((option) => (
                                                <FormControlLabel
                                                    key={option.value}
                                                    value={+option.value}       // ✅ string
                                                    control={<Radio size="small" color="success" />}
                                                    label={option.label}
                                                    sx={{ fontSize: 14 }}
                                                />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                )
                            }
                        </Box>

                        {
                            (user.user_level_id === 1 || user.user_level_id === 2) ? (
                                <Divider sx={{ bgcolor: '#f5f1f1ff' }} />
                            ) : ("")
                        }

                        <Box sx={{ p: 2 }}>
                            <Grid container spacing={1}>
                                {
                                    adOptionFilters.map((field, index) => (
                                        <Grid item size={{ xs: 12, md: 4 }}>
                                            {field.type === "single" ? (
                                                <SingleSelect
                                                    name={field.name}
                                                    label={field.label}
                                                    options={field.options}
                                                    value={field.value}
                                                    disabled={field.disabled}
                                                    onChange={handleInputChange}
                                                    error={field.error}
                                                    formHelperText={true}
                                                />
                                            ) : (
                                                <MultiSelectWithAll
                                                    name={field.name}
                                                    label={field.label}
                                                    options={field.options}
                                                    value={state[field.name] || []}
                                                    onChange={handleMultiSelectChange}
                                                />
                                            )}
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </Box>


                        <Grid container spacing={1} mt={1}>
                            <Grid item size={{ xs: 12, md: 12 }}>
                                <MaterialReactTableWithSearch
                                    data={state.getFilterData}
                                    columns={adOptionColumns}
                                    enableRowActions={rowActions}
                                    renderRowActions={renderRowActions}
                                    manualPagination
                                    isLoading={adOptionLoading}
                                    rowCount={adOptionPagination?.totalRecords ?? 0}
                                    pagination={{ pageIndex: (adOptionPage || 1) - 1, pageSize: adOptionLimit || 10 }}
                                    onPaginationChange={(next) => {
                                        if (next.pageSize !== (adOptionLimit || 10)) {
                                            handleAdOptionLimitChange?.(next.pageSize);
                                        } else {
                                            handleAdOptionPageChange?.(next.pageIndex + 1);
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </>
    );
}
export default AdOptionHistory;